export const name = 'rnFeature';

/**
 * @ngdoc service
 * @name rhino.components.feature.service:rnFeature
 *
 * @description Rhino Feature service, provides methods to get feature settings
 */
export default function rnFeature(rnClient) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let service = {
    getOrganizationFeatures,
    getFeatures,
  };

  return service;

  ////////////////

  /**
   * @ngdoc function
   * @name getOrganizationFeatures
   * @methodOf rhino.components.feature.service:rnFeature
   * @description Gets the features that are enabled for the organization as an array of objects (for backwards compatibility)
   * @returns {Promise.<Array<Object>>} enabled features as an array of feature objects with a "name" property
   */
  function getOrganizationFeatures() {
    return getFeatures().then(features => {
      return features.map(name => ({ name }));
    });
  }

  /**
   * @ngdoc function
   * @name getFeatures
   * @methodOf rhino.components.feature.service:rnFeature
   * @description Provides the enabled features in an array
   * @returns {Promise.<Array<String>>} enabled feature names as an array of strings
   */
  function getFeatures() {
    return rnClient.getConfig()
      .then(function(clientConfig) {
        return clientConfig.features;
      });
  }
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/feature/feature.service.js